export default __webpack_public_path__ + "static/top_staff_img_003-8a460c2099e033b1d1f32a066288d333.jpg";